<mat-toolbar class="mat-accent">
  <mat-toolbar-row fxFlex fxLayout="row" fxLayoutAlign="space-between center">
    <span class="title dialog-title" style="white-space: normal;">Foto de perfil</span>
    <button mat-icon-button (click)="dialogRef.close()" aria-label="Close dialog">
      <mat-icon>close</mat-icon>
    </button>
  </mat-toolbar-row>
</mat-toolbar>

<mat-dialog-content>
  <div style="text-align: center; margin-top: 20px;">
    <img [src]="profileImageUrl || 'assets/img/user.svg'" class="avatar" style="width: 150px; height: 150px; border-radius: 50%;">
  </div>
  <div style="text-align: center; margin-top: 10px; font-size: 10px;"> 
    <span style="color: red;">*La imagen no debe superar los 5Mb y debe ser de formato jpg, jpeg o png</span>
  </div>

 
  <div class="button-group">
    <button mat-button (click)="fileInput.click()" style="background-color: #054884; color: white; margin-right: 10px;">Subir foto</button>
    <input type="file" #fileInput (change)="onFileSelected($event)" accept="image/*" style="display: none;">
    <button mat-button (click)="onDeletePhoto()" style="background-color: #d33; color: white;">Eliminar foto</button>
  </div>

 
  <hr style="margin: 20px 0;">

 
  <div class="button-group">
    <button mat-button (click)="onSave()" style="background-color: #054884; color: white; margin-right: 10px;">Guardar</button>
    <button mat-button (click)="onCancel()" style="background-color: #d33; color: white;">Cancelar</button>
  </div>
</mat-dialog-content>